import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

Vue.use(Vuex)

const extRelativePath = '../';//エクステリア位置までの相対パス（JSON内部のパス指定関連値がエクステリア起点のためインテリアでは1階層ずらす必要がある）

const query = (()=>{
  var data={};
  if(location.search){
    var arr=location.search.substring(1,location.search.length).split('&');
    var split;
    for(var i=0;i<arr.length;i++){
      split = arr[i].split('=');
      data[split[0]] = split[1]!=null?split[1]:'';
    }
  }
  return data;
})();

export default new Vuex.Store({
  state: {
    queryParam: query,//クエリ
    currentGradeId: null,//選択中のグレード
    activeFeatureId: null,//選択中の訴求ポイントID
    showFeatureMarker: true,//訴求ポイントマーカー表示のオンオフ
    showGradeList: false,//グレードリストの表示フラグ
    gradeList: [],//グレード一覧配列 {id:グレードid,thumbnail:サムネイル,label:グレード名称}の形式で格納
    material:{},//グレードidをキーにマテリアルJSONの内容を格納
    features:{},//グレードidをキーに訴求ポイントJSONの内容を格納
    captions:{},//グレードidをキーにキャプションの内容を格納
    materialDirPath: '',//グレードリストJSONで指定されるマテリアル階層パス
    isTabletMode: query.tablet!=null,//タブレットモード（tabletクエリの有無で決定）
  },
  getters: {
    //全天球画像パス
    mainImagePath: (state) => {
      let path = null;
      if(state.currentGradeId && state.material[state.currentGradeId].length){
        path = extRelativePath + state.materialDirPath + state.material[state.currentGradeId][0].material+'/'+state.material[state.currentGradeId][0].material+'.jpg';
      }
      return path;
    },
    //選択中のグレードの訴求ポイントで表示可能なデータ
    enabledFeatures: (state) => {
      let res = {};
      if(state.features[state.currentGradeId]){
        for(let featureId in state.features[state.currentGradeId]){
          if(state.features[state.currentGradeId][featureId].visible){//visibleが偽の物を除外
            res[featureId] = state.features[state.currentGradeId][featureId];
          }
        }
      }
      return res;
    },
    //選択中の訴求ポイント
    activeFeature:  (state, getters) => {
      let res = null;
      if(state.activeFeatureId){
        res = getters.enabledFeatures[state.activeFeatureId]
      }
      return res;
    },
    //選択中のグレードのキャプション文書
    gradeCaption: (state) => {
      let caption = '';
      if(state.currentGradeId){
        caption = state.captions[state.currentGradeId]||'';
      }
      return caption;
    },
  },
  mutations: {
    changeShowGradeList(state, flg){
      state.showGradeList = !!flg;
    },
    changeActiveFeatureId(state, featureId){
      state.activeFeatureId = featureId||null;
    },
    changeShowFeatureMarker(state, flg){
      state.showFeatureMarker = flg;
    },
    setMaterialDirPath(state, path) {
      state.materialDirPath = path;
    },
    changeGrade (state, gradeId) {
      state.currentGradeId = gradeId;
    },
    addGrade (state, payload){
      const id = payload.id;
      const thumbnail = payload.thumbnail||'';
      const label = payload.label||'';
      state.gradeList.push({id,thumbnail,label});
    },
    addMaterial (state, payload){
      const id = payload.id;
      const preset = state.material[id]||[];
      Vue.set(state.material, id, preset.concat(payload.material));
    },
    addFeatures (state, payload){
      const id = payload.id;
      const preset = state.features[id]||{};
      Vue.set(state.features, id, {...preset, ...payload.features});
    },
    addCaptions (state, payload){
      const id = payload.id;
      const caption = payload.interior_caption||'';
      Vue.set(state.captions, id, caption);
    }
  },
  actions: {
    changeGrade(context,gradeId){
      context.commit('changeGrade',gradeId);
    },
    displayGradeList(context, flg){
      context.commit('changeShowGradeList',flg);
    },
    displayFeature(context, featureId){
      context.commit('changeActiveFeatureId',featureId);
    },
    featureMarkerVisibleChange(context, flg){
      context.commit('changeShowFeatureMarker',flg);
    },
    //グレードリストJSONを取得して値を返却
    async requestGradeListJson(){
      return await axios.get('../../assets/setting/grade_list.json');
    },
    //各JSONを取得して全データをセットする（初回時に一回実行）
    async setData(context){
      const gradeListJson = await context.dispatch('requestGradeListJson');
      const jsonRootPath = extRelativePath + gradeListJson.data.GRADE.jsonDirPath;
      context.commit('setMaterialDirPath', gradeListJson.data.GRADE.materialDirPath);
      let defaultGrade;//初期表示グレード
      let querySelectGrade;//クエリで選択されたグレード
      gradeListJson.data.GRADE.groups[0].items.forEach((item)=>{
        const gradeId = item.item_id;
        if(context.state.queryParam.grade && context.state.queryParam.grade === gradeId){
          querySelectGrade = gradeId;
        }
        if(item.interior_checked === true){
          defaultGrade = gradeId;
        }else if(item.interior_checked == null){
          return true;
        }
        const label = item.label;
        const thumbnail = item.interiorThumbnail||item.thumbnail;
        const interior_caption = item.interior_caption;
        context.commit('addGrade',{id:gradeId,label,thumbnail});
        context.commit('addCaptions',{id:gradeId,interior_caption});
        //一旦空のmaterial,featuresを作成する
        context.commit('addMaterial',{id:gradeId,material:[]});
        context.commit('addFeatures',{id:gradeId,features:{}});
        //マテリアルJSONを取得
        axios.get(`${jsonRootPath}${item.files.materials}`)
        .then((res)=>{
          context.commit('addMaterial',{id:gradeId,material:res.data.MATERIALS.INT});
        });
        //訴求ポイントJSONを取得
        axios.get(`${jsonRootPath}${item.files.features}`)
        .then((res)=>{
          context.commit('addFeatures',{id:gradeId,features:res.data.FEATURES.INT});
        });
      });
      //初期表示グレートを反映
      if(querySelectGrade){//クエリ指定を優先
        defaultGrade = querySelectGrade;
      }
      if(!defaultGrade){
        defaultGrade = context.state.gradeList[0].id;
      }
      context.commit('changeGrade',defaultGrade);
    }
  },
  
})
